export default "__VITE_ASSET__Bd5Cy5iX__"